import FastMarquee from "react-fast-marquee";

const ITEMS = [
  "Kesintisiz Erişim",
  "Güvenli Altyapı",
  "Merkezi Yönetim",
  "Uzaktan Destek",
  "Anlık İzleme",
  "Otomatik Uyarılar",
];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-b border-black/5 bg-[#FAFAFA] py-10 md:py-14"
      aria-hidden="true"
    >
      <FastMarquee speed={30} gradient={false}>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-16">
            <span className="font-display text-3xl font-bold uppercase tracking-tight text-outline md:text-5xl">
              {item}
            </span>
            <span className="h-2 w-2 rounded-full bg-[#003366]/30" />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
